<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { acquisitionNetwork } from './acquisitionNetwork';

const props = defineProps({
  acquisition: { type: Object, default: () => ({}) },
  expanded: { type: Boolean, default: false },
});
const { t } = useI18n();
const fields = computed(() => props.acquisition?.fields || {});
const network = computed(() => acquisitionNetwork(fields.value));
const summary = computed(() => [
  { label: t('ACQUISITION.ORIGIN'), value: network.value.name },
  {
    label: t('ACQUISITION.CAMPAIGN'),
    value: fields.value.utm_campaign || fields.value.campaign_id,
  },
  {
    label: t('ACQUISITION.ADSET'),
    value: fields.value.utm_term || fields.value.adset_id,
  },
  {
    label: t('ACQUISITION.AD'),
    value: fields.value.utm_content || fields.value.ad_id,
  },
]);
</script>

<template>
  <div class="space-y-3 text-xs text-n-slate-12">
    <dl class="space-y-2">
      <div v-for="row in summary" :key="row.label">
        <dt class="text-n-slate-11">{{ row.label }}</dt>
        <dd class="break-words font-medium">
          {{ row.value || t('ACQUISITION.UNKNOWN') }}
        </dd>
      </div>
    </dl>
    <p v-if="acquisition.scope !== 'conversation'" class="text-n-slate-10">
      {{ t('ACQUISITION.CONTACT_SCOPE') }}
    </p>
    <details class="border-t border-n-weak pt-2" :open="expanded">
      <summary class="cursor-pointer font-medium">
        {{ t('ACQUISITION.PARAMETERS') }}
      </summary>
      <dl class="mt-2 space-y-2">
        <div
          v-for="(value, key) in fields"
          :key="key"
          class="grid grid-cols-1 gap-0.5"
        >
          <dt class="font-mono text-n-slate-10">{{ key }}</dt>
          <dd class="break-words">{{ value }}</dd>
        </div>
      </dl>
    </details>
  </div>
</template>
